import { DataManager } from "../model/DataManager.js";
import { VOVideo } from "../model/DataStructure.js";
import { Language } from "../model/Language.js";
import { PlayButton } from "./PlayButton.js";
import { VideoText } from "./VideoText.js";

export class IdlemodeGallery {

    public element: HTMLElement;

    private _videos: VOVideo[] = [];
    private _a: IdlemodeGalleryItem = null;
    private _b: IdlemodeGalleryItem = null;
    private _current: IdlemodeGalleryItem = null;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.className = "idlemode-gallery";

        this._videos = this._data.config.videos.slice();

        this._a = new IdlemodeGalleryItem(this._data);
        this.element.appendChild(this._a.element);
        this._b = new IdlemodeGalleryItem(this._data);
        this.element.appendChild(this._b.element);

        this.open(this._videos[0]);

        this.element.style.opacity = "0";

        var play = new PlayButton(200, 10, "icon-739");
        this.element.appendChild(play.element);
        play.element.style.zIndex = "2000";
        play.start();
        play.onComplete.add(() => {
            this.next();
            play.start();
        });
    }

    private next(): void {
        if (!this.element.parentElement) {
            return;
        }

        var index = this._videos.indexOf(this.video);
        if (index == -1) {
            index = 0;
        }

        index = e5.Calc.wrap(index + 1, this._videos.length);
        this.open(this._videos[index]);
    }

    public show(): void {
        this.element.classList.add("active");
        document.getElementById("app").appendChild(this.element);
        gsap.to(this.element, { duration: 1, opacity: 1 });
    }

    public hide(): void {
        this.element.classList.remove("active");
        gsap.to(this.element, {
            duration: 1,
            opacity: 0,
            onComplete: () => {
                this.element.remove();
            }
        });
    }

    private open(video: VOVideo): void {
        var next = this._current == this._a ? this._b : this._a;
        next.video = video;
        this.current = next;
    }

    private get current(): IdlemodeGalleryItem {
        return this._current;
    }

    private set current(value: IdlemodeGalleryItem) {
        if (this._current == value) {
            return;
        }

        if (this._current) {
            this._current.active = false;
        }
        this._current = value;
        if (this._current) {
            this._current.active = true;
        }
    }

    public get video(): VOVideo {
        return this._current ? this._current.video : null;
    }
}

class IdlemodeGalleryItem {
    public element: HTMLElement;

    private _video: VOVideo = null;

    private _poster: HTMLDivElement;
    private _text: VideoText;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.className = "idlemode-gallery-item";
        this.element.innerHTML = `
            <div class="idlemode-gallery-item-poster"></div>
            <div class="idlemode-gallery-item-text"></div>
        `;

        this._poster = this.element.querySelector(".idlemode-gallery-item-poster");
        this._text = new VideoText(this._data);
        this.element.querySelector(".idlemode-gallery-item-text").appendChild(this._text.element);
    }

    public set video(video: VOVideo) {
        this._video = video;
        this._text.video = video;

        if (this._video) {
            this._poster.style.backgroundImage = `url(${Language.trans(this._video.preview_de, this._video.preview_en)})`;
        }
    }

    public get video(): VOVideo {
        return this._video;
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(value: boolean) {
        this.element.classList.toggle("active", value);
        this._poster.classList.toggle("active", value);

        if (value) {
            //Reset animation
            this._poster.style.animation = "none";
            this._poster.offsetWidth;
            this._poster.style.animation = null;
        }
    }
}